module.exports = __webpack_public_path__ + "static/media/404-movil.1d28b317.png";